<template>
  <div class="orderDetails">
    <el-button
      :loading="disabled"
      type="primary"
      @click="exportFun"
      plain
      style="float: right; margin-bottom: 12px"
      ><i class="el-icon-download el-icon--left"></i>
      导出
    </el-button>
    <el-descriptions title="" border :column="2" style="margin-bottom: 30px">
      <el-descriptions-item label="工单名称">
        {{ activeItem.description }}
      </el-descriptions-item>
      <el-descriptions-item label="工单类型">维修</el-descriptions-item>
      <el-descriptions-item label="设备信息">
        {{ activeItem.deviceName }}
      </el-descriptions-item>
      <el-descriptions-item label="工单地址">
        {{ activeItem.location }}
      </el-descriptions-item>
      <el-descriptions-item label="工单级别">
        {{ activeItem.level }}
      </el-descriptions-item>
      <el-descriptions-item label="上报图片">
        <el-image
          v-for="(item, index) in activeItem.imgInfo"
          :key="index"
          style="width: 35px; height: 35px; margin-right: 5px"
          :src="item.imgUrl"
          :preview-src-list="[item.imgUrl]"
        ></el-image>
      </el-descriptions-item>
      <el-descriptions-item label="工单描述">
        {{ activeItem.remark }}
      </el-descriptions-item>
      <el-descriptions-item label="满意度评价">
        <el-rate v-model="starNumber" disabled></el-rate>
      </el-descriptions-item>
      <el-descriptions-item label="评价内容">
        {{ comment.comment ?? "" }}
      </el-descriptions-item>
    </el-descriptions>
    <el-steps direction="vertical">
      <el-step v-for="(v, i) in stepList" :key="i" :title="v.handleStaffInfo">
        <template slot="description">
          <div class="contentWrap">
            <p>
              {{ v.result }} <span>{{ v.time }}</span>
            </p>
            <p>备注:{{ v.remark ? v.remark : "无" }}</p>
            <el-image
              v-for="(item, index) in v.imgInfo"
              :key="index"
              style="
                width: 50px;
                height: 50px;
                margin-right: 5px;
                margin-top: 10px;
              "
              :src="item.imgUrl"
              :preview-src-list="[item.imgUrl]"
            ></el-image>
            <p v-if="v.ts">处理时长:{{ v.duration }}</p>
          </div>
        </template>
      </el-step>
    </el-steps>
  </div>
</template>

<script>
import api from "@/api";
import { dateFtt, formatTime } from "@/assets/js/utils";
import { exportBlobFileFun } from "@/assets/utils/exportWord";
import axios from "axios";
export default {
  props: ["activeItem"],
  data() {
    return {
      stepList: [],
      disabled: false,
      starNumber: null,
      comment: {},
    };
  },
  methods: {
    async getRecordList() {
      let res = await api.logisticsOrderRecordList({
        id: this.activeItem.id,
      });
      if (res && res.data.code == 200) {
        this.stepList = res.data.data;
        this.stepList.forEach((v) => {
          v.duration = v.ts ? formatTime(v.ts) : "";
          v.time = v.createTime
            ? dateFtt("yyyy-MM-dd hh:mm", new Date(v.createTime))
            : "";
          if (v.imgInfo && v.imgInfo.length) {
            v.imgInfo.forEach((item) => {
              if (item.imgUrl) {
                let httpUrl = window.jujiParams.baseURL;
                item.imgUrl = `${httpUrl}/${item.imgUrl}?tenant_id=${
                  JSON.parse(window.sessionStorage.getItem("userInfo")).tenantId
                }`;
              }
            });
          }
          if (v.action == "CREATE") {
            v.result = "上报工单";
          } else if (v.action == "ASSIGN") {
            v.result = "派单至" + v.assignStaffInfo;
          } else if (v.action == "RE_ASSIGN") {
            v.result = "重新派单至" + v.assignStaffInfo;
          } else if (v.action == "REPAIR") {
            v.result = "已处理";
          } else if (v.action == "NO_NEED_REPAIR") {
            v.result = "无需维修 - 待确认";
          } else if (v.action == "UNABLE_REPAIR") {
            v.result = "无法处理";
          } else if (v.action == "CONFIRM") {
            v.result = "已确认";
          } else if (v.action == "CANCEL") {
            v.result = "已关闭";
          }
        });
        this.stepList.reverse();
        this.$nextTick(() => {
          [
            ...document.querySelectorAll(".el-steps .el-step__icon div"),
          ].forEach((el, index, arr) => {
            // console.log(el, arr.length - index); // 3,2,1
            el.innerHTML = arr.length - index;
          });
        });
      }
    },
    async getCommentList() {
      let res = await api.logisticsOrderComment({
        id: this.activeItem.id,
      });
      if (res && res.data.code == 200) {
        this.comment = res.data.data;
        this.starNumber = Number(this.comment.star);
      }
    },
    exportFun() {
      this.disabled = true;
      let timer = setTimeout(() => {
        this.$message.info("文件正在下载中,请稍后!");
      }, 500);
      let params = {
        id: this.activeItem.id,
      };
      let token = window.sessionStorage.getItem("token");
      let http = window.jujiParams.baseURL;
      axios({
        timeout: 6 * 60 * 1000,
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "X-Authorization": `Bearer ${token}`,
        },
        url: http + "/api/odoo/workOrder/downloadWord",
        method: "get",
        responseType: "blob",
        params,
      })
        .then((res) => {
          this.disabled = false;
          try {
            exportBlobFileFun(
              res.data,
              `${this.activeItem.description}-详情.docx`
            );
            clearTimeout(timer);
          } catch (err) {
            console.log("---catch-----", err);
            // const decoder = new TextDecoder("utf-8");
            // const str = decoder.decode(res.data);
            // const result = JSON.parse(str);
            this.$message.error(err);
            clearTimeout(timer);
          }
          // const decoder = new TextDecoder("utf-8");
          // const str = decoder.decode(res.data);
          // try {
          //   const result = JSON.parse(str);
          //   this.$message.error(result.data);
          //   clearTimeout(timer);
          // } catch (err) {
          //   const url = URL.createObjectURL(new Blob([res.data]));
          //   const link = document.createElement("a");
          //   link.style.display = "none";
          //   link.href = url;
          //   link.download = `详情`;
          //   document.body.appendChild(link);
          //   link.click();
          //   window.URL.revokeObjectURL(url);
          // }
        })
        .catch((error) => {
          this.disabled = false;
          clearTimeout(timer);
          this.$message.error(JSON.parse(error.response).message);
        });
    },
  },
  created() {
    this.getRecordList();
    this.getCommentList();
  },
};
</script>

<style lang="scss" scoped>
.orderDetails {
  width: 95%;
  margin: 0 auto;
  ::v-deep .el-descriptions {
    th {
      width: 120px;
    }
  }
  ::v-deep .el-step__title {
    color: #333;
    padding-bottom: 0;
    font-weight: 500;
  }

  ::v-deep .el-steps {
    .el-step {
      .el-step__head {
        border-color: #d0d0d0;
        color: #fff;
        // color: red !important;
        .el-step__line {
          background: #d0d0d0;
        }
        .el-step__icon {
          background: #d0d0d0;
        }
      }
    }
    .el-step:nth-child(1) {
      .el-step__head {
        border-color: #28cccb;
        color: #fff;
        // color: red !important;
        .el-step__line {
          background: #28cccb;
        }
        .el-step__icon {
          background: #28cccb;
        }
      }
    }
  }
  .contentWrap {
    margin: 10px 0 20px 0;
    p:nth-child(1) {
      color: #333 !important;
      span {
        margin-left: 10px;
        color: #666;
      }
    }
    p:nth-child(2) {
      color: #666;
    }
  }
}
</style>
